import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import {
    Container, Table, Button, Input, Form, FormGroup,
    Label, Alert, Spinner, Card, CardBody, CardHeader
} from 'reactstrap';

import { useDispatch, useSelector } from 'react-redux';


const FileManagerComponent = () => {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);


    const tenantId = useSelector((state) => state.Context.tenantId)

    // 1. Listar archivos
    const fetchFiles = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`https://erp-backend.siga-ltda.click/files-agent/files?tenantId=${tenantId}`);
            setFiles(response);
        } catch (err) {
            setError('No se pudieron cargar los archivos.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchFiles();
    }, [fetchFiles]);

    // 2. Manejar selección de archivo
    const onFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    // 3. Subir archivo
    const handleUpload = async (e) => {
        e.preventDefault();
        if (!selectedFile) return;

        const formData = new FormData();
        formData.append('file', selectedFile);

        setUploading(true);
        try {
            await axios.post(`https://erp-backend.siga-ltda.click/files-agent/upload?tenantId=${tenantId}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setSelectedFile(null);
            document.getElementById('fileInput').value = ''; // Reset input
            fetchFiles(); // Refrescar lista
        } catch (err) {
            const msg = err.response?.status === 423
                ? 'Archivo bloqueado por el ERP en el servidor.'
                : 'Error al subir el archivo.';
            setError(msg);
        } finally {
            setUploading(false);
        }
    };

    // 4. Descargar archivo
    const handleDownload = async (fileName) => {
        try {
            const response = await axios.get(`https://erp-backend.siga-ltda.click/files-agent/download/${encodeURIComponent(fileName)}?tenantId=${tenantId}`, {
                responseType: 'blob', // Vital para recibir archivos binarios
            });

            // Crear un link temporal en el DOM para forzar la descarga
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName.split('/').pop()); // Extrae el nombre del archivo
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            setError('Error al descargar el archivo.');
        }
    };

    const formatSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    return (
        <Container className="mt-5">
            <Card shadow className="mb-4">
                <CardBody>
                    {/* Formulario de Carga */}
                    <Form onSubmit={handleUpload} className="mb-4 inline">
                        <FormGroup className="d-flex gap-2 align-items-end">
                            <div className="flex-grow-1">
                                <Label for="fileInput">Subir nuevo archivo</Label>
                                <Input
                                    type="file"
                                    id="fileInput"
                                    onChange={onFileChange}
                                    disabled={uploading}
                                />
                            </div>
                            <Button color="success" type="submit" disabled={!selectedFile || uploading}>
                                {uploading ? <Spinner size="sm" /> : 'Subir'}
                            </Button>
                        </FormGroup>
                    </Form>

                    {error && <Alert color="danger">{error}</Alert>}

                    {/* Tabla de Archivos */}
                    {loading ? (
                        <div className="text-center"><Spinner color="primary" /></div>
                    ) : (
                        <Table hover responsive striped>
                            <thead>
                                <tr>
                                    <th>Nombre del Archivo / Ruta</th>
                                    <th>Tamaño</th>
                                    <th>Última Modificación</th>
                                    <th className="text-end">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {files.length > 0 ? files.map((file, idx) => (
                                    <tr key={idx}>
                                        <td className="align-middle">
                                            <code>{file.name}</code>
                                        </td>
                                        <td className="align-middle">{formatSize(file.size)}</td>
                                        <td className="align-middle">
                                            {new Date(file.lastModified).toLocaleString()}
                                        </td>
                                        <td className="text-end">
                                            <Button
                                                outline
                                                color="primary"
                                                size="sm"
                                                onClick={() => handleDownload(file.name)}
                                            >
                                                Descargar
                                            </Button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="4" className="text-center text-muted">No hay archivos disponibles</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    )}
                </CardBody>
            </Card>
        </Container>
    );
};

export default FileManagerComponent;